import GrowingList from './GrowingList';
import GrowingShow from './GrowingShow';
import { Eco } from '@material-ui/icons';

export default {
  list: GrowingList,
  show: GrowingShow,
  icon: Eco,
};
